export const normalizeTextByLength = (stringMaxLength: number) => (value?: string) =>
  value && value.length > stringMaxLength ? `${value.slice(0, stringMaxLength)}...` : value || '';
